import React from 'react';
import { Toaster as HotToaster } from 'react-hot-toast';

interface LocalToasterProps {
  position?: 'top-center' | 'top-left' | 'top-right' | 'bottom-center' | 'bottom-left' | 'bottom-right';
  reverseOrder?: boolean;
  gutter?: number;
  containerClassName?: string;
  containerStyle?: React.CSSProperties;
  toastOptions?: {
    duration?: number;
    style?: React.CSSProperties;
    className?: string;
  };
}

const LocalToaster: React.FC<LocalToasterProps> = ({
  position = 'bottom-right',
  reverseOrder = false,
  gutter = 8,
  containerClassName = '',
  containerStyle = {},
  toastOptions = {},
}) => {
  return (
    <HotToaster
      position={position}
      reverseOrder={reverseOrder}
      gutter={gutter}
      containerClassName={`react-hot-toast-container ${containerClassName}`}
      containerStyle={{
        zIndex: 9999,
        ...containerStyle,
      }}
      toastOptions={{
        duration: 4000,
        style: {
          background: 'transparent',
          border: 'none',
          boxShadow: 'none',
          padding: 0,
          margin: 0,
          maxWidth: 'none',
          width: 'auto',
        },
        ...toastOptions,
      }}
    />
  );
};

export default LocalToaster;
